<div class="my-2 mb-4">
  <div class="row">
    <div class="col">
      <ion-label class="color-medium text-uppercase">{{
        'P00039.lighting.functionality.controle.mode' | translate
      }}</ion-label>
    </div>
  </div>
  <div class="my-3">
    <app-mode-control-multiple
      [datas]="[
        {
          ref: 1,
          label: 'P00039.lighting.fonctionality.controle.on' | translate,
          icon: 'fa-kit fa-picto-on',
          color: 'color-green',
        },
        {
          ref: 0,
          label: 'P00039.lighting.fonctionality.controle.off' | translate,
          icon: 'fa-kit fa-picto-off',
          color: 'color-red',
        },
        {
          ref: 2,
          label: 'P00039.lighting.fonctionality.controle.clock' | translate,
          icon: 'fa-kit fa-picto-horloge',
          color: 'color-orange',
        },
      ]"
      [value]="
        this.actionStack!.getValue('eclairageStandardCModeFonctionnement')
      "
      (onChange)="
        this.actionStack!.editValue(
          P00039DataRxTxIndex.Eclairage_Controle,
          'eclairageStandardCModeFonctionnement',
          $event
        );
        this.actionStack!.commit()
      "
    >
    </app-mode-control-multiple>
  </div>
</div>

<div class="my-2 mb-4">
  <div class="row">
    <div class="col">
      <ion-label class="color-medium text-uppercase">{{
        'P00039.lighting.functionality.controle.timer' | translate
      }}</ion-label>
    </div>
  </div>
  <div class="my-3">
    <div class="row">
      <div class="col-12 mb-3">
        <div class="d-inline-block" style="width: 255px">
          <div
            class="box-white-rounded-xs p-4 position-relative pointer-hover"
            (click)="openDateSelector()"
          >
            <div class="position-absolute top-0 end-0 p-3">
              <i class="fa-regular fa-stopwatch color-primary"></i>
            </div>

            <div class="row h-100">
              <div class="col text-center fs-20 fw-bold">
                @if (
                  this.actionStack!.getValue(
                    'eclairageStandardCDemarrageMinuterie'
                  ) === 0
                ) {
                  {{
                    convertMinutesToTime(
                      this.actionStack!.getValue(
                        'eclairageStandardPDureeMinuterie'
                      ),
                      true
                    )
                  }}
                } @else {
                  {{
                    convertSecondsToTime(
                      this.actionStack!.getValue(
                        'eclairageStandardSCompteAReboursMinuterie'
                      )
                    )
                  }}
                }
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12">
        <app-mode-control-multiple
          [datas]="[
            {
              ref: 1,
              label: 'P00039.lighting.fonctionality.controle.on' | translate,
              icon: 'fa-kit fa-picto-on',
              color: 'color-green',
            },
            {
              ref: 0,
              label: 'P00039.lighting.fonctionality.controle.off' | translate,
              icon: 'fa-kit fa-picto-off',
              color: 'color-red',
            },
          ]"
          [value]="
            this.actionStack!.getValue('eclairageStandardCDemarrageMinuterie')
          "
          (onChange)="
            this.actionStack!.editValue(
              P00039DataRxTxIndex.Eclairage_Controle,
              'eclairageStandardCDemarrageMinuterie',
              $event
            );
            this.actionStack!.commit()
          "
        >
        </app-mode-control-multiple>
      </div>
    </div>
  </div>
</div>

<div class="my-2 mb-4">
  <div class="row">
    <div class="col">
      <ion-label class="color-medium text-uppercase">{{
        'P00039.lighting.functionality.controle.programme' | translate
      }}</ion-label>
    </div>
  </div>
  <div class="my-3">
    @if (
      this.actionStack!.getValue('eclairageStandardITypeEclairage') === 3 ||
      this.actionStack!.getValue('eclairageStandardITypeEclairage') === 4
    ) {
      <div class="me-3 d-inline-block">
        <app-mode-control-simple
          [data]="getColorData()"
          (onPress)="openColorSelector()"
        >
        </app-mode-control-simple>
      </div>
    } @else if (
      this.actionStack!.getValue('eclairageStandardITypeEclairage') === 0
    ) {
      <div class="me-3 d-inline-block">
        <app-mode-control-simple
          [data]="{
            label:
              'P00039.lighting.functionality.controle.programme.next'
              | translate,
            icon: 'fa-regular fa-arrow-right-from-line',
          }"
          (onPress)="
            this.actionStack!.editValue(
              P00039DataRxTxIndex.Eclairage_Controle,
              'eclairageStandardCProgrammeSuivant',
              1
            );
            this.actionStack!.commit()
          "
        >
        </app-mode-control-simple>
      </div>
    } @else {
      <div class="me-3 d-inline-block">
        <app-mode-control-simple
          [data]="{
            label:
              'P00039.lighting.functionality.controle.programme.next'
              | translate,
            icon: 'fa-regular fa-arrow-right-from-line',
          }"
          (onPress)="
            this.actionStack!.editValue(
              P00039DataRxTxIndex.Eclairage_Controle,
              'eclairageStandardCProgrammeSuivant',
              1
            );
            this.actionStack!.commit()
          "
        >
        </app-mode-control-simple>
      </div>
      <div class="me-3 d-inline-block">
        <app-mode-control-simple
          [data]="{
            label:
              'P00039.lighting.functionality.controle.programme.synchro'
              | translate,
            icon: 'fa-regular fa-arrows-rotate',
          }"
          (onPress)="
            this.actionStack!.editValue(
              P00039DataRxTxIndex.Eclairage_Controle,
              'eclairageStandardCSynchronisationProgramme',
              1
            );
            this.actionStack!.commit()
          "
        >
        </app-mode-control-simple>
      </div>
    }
  </div>
</div>
